import React, { useState, useEffect, useContext } from 'react';
import OtpAuth from './OtpAuth';
import { UserContext } from '../../../../../context/UserContext';

function ProtectedEmailRoute({ children }) {
    const [isVerified, setIsVerified] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { user } = useContext(UserContext);

    // Check if OTP is already verified on component mount
    useEffect(() => {
        const checkVerification = () => {

            const verified = localStorage.getItem('emailAutomationOtpVerified') === 'true';
            const verificationTime = localStorage.getItem('emailAutomationOtpVerifiedTime');
            
            // If verified, check if it's expired (5 minutes)
            if (verified && verificationTime) {
                const currentTime = new Date().getTime();
                const verificationTimestamp = parseInt(verificationTime);
                const fiveMinutesInMillis = 5 * 60 * 1000; // 5 minutes in milliseconds
                
                // Check if verification is older than 5 minutes
                if (currentTime - verificationTimestamp > fiveMinutesInMillis) {
                    // Expired - clear verification status
                    localStorage.removeItem('emailAutomationOtpVerified');
                    localStorage.removeItem('emailAutomationOtpVerifiedTime');
                    setIsVerified(false);
                } else {
                    // Still valid
                    setIsVerified(true);
                }
            } else {
                // Not verified or no timestamp
                setIsVerified(verified);
            }
            setIsLoading(false);
        };

        checkVerification();
    }, []);

    // Handle successful OTP verification
    const handleVerificationSuccess = () => {
        setIsVerified(true);
        // Store verification status and timestamp in localStorage
        localStorage.setItem('emailAutomationOtpVerified', 'true');
        localStorage.setItem('emailAutomationOtpVerifiedTime', new Date().getTime().toString());
    };

    // Handle logout or manual verification reset
    const handleLogout = () => {
        setIsVerified(false);
        localStorage.removeItem('emailAutomationOtpVerified');
        localStorage.removeItem('emailAutomationOtpVerifiedTime');
    };

    // Show loading state while checking verification
    if (isLoading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                Checking authentication...
            </div>
        );
    }

    // If verified, render children; otherwise, show OTP auth component
    return isVerified ? (
        <>
            {children}
            {/* Optional: Add a logout button for testing purposes */}
            {/*
            <button 
                onClick={handleLogout}
                style={{
                    position: 'fixed',
                    top: '10px',
                    right: '10px',
                    zIndex: 1000,
                    padding: '10px 15px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                }}
            >
                Logout from Email Automation
            </button>
            */}
        </>
    ) : (
        <OtpAuth 
            onVerificationSuccess={handleVerificationSuccess} 
            user={user}
        />
    );
}

export default ProtectedEmailRoute;
